<template>
  <keep-alive :include="['InterviewList']">
    <div v-if="isMobile" class="mobile-tips">{{ '移动端暂不支持，请前往PC查看' }}</div>
    <router-view v-else />
  </keep-alive>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      isMobile: 'isMobile',
    }),
  },
}
</script>
<style lang="scss">
  * {
    margin: 0;
    padding: 0;
  }
  html,
  body {
    height: 100vh;
    font-size: 14px;
    font-family: var(--kd-font-family);
    color: var(--kd-color-text-primary);
  }
  body {
    // fix: 修复输入JD等信息时，简历预览iframe抖动（禁用全局滚动条，临时方案）
    overflow-y: hidden;
    background-color: #fff;
  }
  textarea {
    font-family: var(--kd-font-family);
  }
  #webpack-dev-server-client-overlay {
    display: none;
  }
</style>
<style lang="scss" scoped>
.mobile-tips {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #666;
}
</style>
